import React, { useState, useEffect, useRef } from "react";
import { injectIntl } from "react-intl";
import { useHistory, useLocation } from "react-router-dom"; // useHistory와 useLocation 추가
import Tooltip from '@mui/material/Tooltip';
import 'react-toastify/dist/ReactToastify.css'; // 이 import 추가
import {
  Box,
  Typography,
  Stack,
  IconButton,
  Button,
  InputAdornment,
  Chip,
} from "@mui/material";
import {
  ActionBox,
  DialogBox,
  LeftButtonStyle,
  RightButtonStyle,
  TextStyle,
  TitleText,
} from "@/views/CommonComponent/Styled/CommonDialogStyled";
import {
  WifiListTitle,
  HeaderTitle,
  WifiList,
  WifiItem,
  AddNewWifi,
  ModalContent,
} from "./Styled/WifiConnectStyled";
import { InputField } from "../SignIn/Styled/SignInStyled";
import { LinkButton } from "@/common/Styled/CommonStyled";
import { inject, observer } from "mobx-react";
import { Icon } from "@iconify/react";
import { ReactComponent as Wifi3Lock } from "@/common/Icons/wifi-3-lock.svg";
import { ReactComponent as Wifi2Lock } from "@/common/Icons/wifi-2-lock.svg";
import { ReactComponent as Wifi1Lock } from "@/common/Icons/wifi-1-lock.svg";
import { LineStyle } from "../Setting/Styled/SettingStyled";
import { usePenStatus } from "../../nativebridge/PenStatus"; // 커스텀 훅을 import
import CommonLoading from "@/views/CommonComponent/CommonLoading";
import ComfirmDialog from "@/views/CommonComponent/ComfirmDialog";
import CommonDialog from "@/views/CommonComponent/CommonDialog";
import TitleBox from "../CommonComponent/TitleBox";
import { ContentsBox, ListBox } from "../Setting/Styled/SettingStyled";
import {
  startWifiScan,
  wifiInputPassword,
  OnDeviceConnectedWifiResult,
  reqPokoroConnectedWifiList,
  disConnectPokoro,
  reqRemoveWifi
} from "../../nativebridge/JsToNative";
import {
  NativeToJsBridge,
  NativeToJsEventName,
  getPlatform,
} from "../../nativebridge/NativeToJs";
import { useToast } from '../../components/useToast';
import { LocalStorageConnectSkip } from "../../stores/AuthStore";

// 컴포넌트 외부에 전역 변수 추가
let currentWifiNetwork = null;
let originalWifiNetworksCache = [];  // 원본 Wi-Fi 네트워크 캐시 추가


function WifiConnect(props) {
  const { intl } = props;
  const history = useHistory();
  const location = useLocation(); // 현재 위치 정보 가져오기
  const [selectedNetwork, setSelectedNetwork] = useState(-1);
  const [selectedConnectedNetwork, setSelectedConnectedNetwork] = useState(-1);
  const [openModal, setOpenModal] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loadingText, setLoadingText] = useState(
    intl.formatMessage({ id: "searching_to_wifi" })
  );
  const [open, setOpen] = useState(false);
  const [openTooltip, setOpenTooltip] = useState(false);
  const [selectedDeleteIndex, setSelectedDeleteIndex] = useState(-1);
  const [selectedWifiInfo, setSelectedWifiInfo] = useState(null);
  const [isIntentionalDisconnect, setIsIntentionalDisconnect] = useState(false);

  const { showDeleteToast, showErrorToast, showSuccessToast } = useToast();

  const handleTooltipToggle = () => {
    setOpenTooltip((prevOpen) => !prevOpen);
  };

  // 펜 연결 여부 확인
  const { globalPenStatus, setGlobalPenStatus } = usePenStatus();
  const [wifiNetworks, setWifiNetworks] = useState([]);
  const [wifiConnectedList, setWifiConnectedList] = useState([]);
  const [loading, setLoading] = React.useState(false);
  const [disconnect, setDisconnect] = React.useState(false);
  const [wifiConnected, setWifiConnected] = React.useState(false);
  const [wifiConnectFail, setWifiConnectFail] = React.useState(false);
  const [wifiFailReasonTitle, setWifiFailReasonTitle] = React.useState("");
  const [wifiFailReasonMsg, setWifiFailReasonMsg] = React.useState("");
  const platform = getPlatform();
  const mapWifiConnectedList = new Map();
  const [connectedWifiInfo, setConnectedWifiInfo] = useState(null);


  const from = location.state?.from;

  const queryParams = new URLSearchParams(location.search);
  const showToast = queryParams.get("connectByPokoroSetting") === "true";

  console.log('Current wifiNetworks:', wifiNetworks);

  /* 와이파이 삭제 토스트 메시지 */
  const DeleteWifi = () => {
    if (selectedDeleteIndex !== -1) {
      const deletedWifiName = wifiConnectedList[selectedDeleteIndex].name;
      console.log(`handleConnectedNetworkDelete reqRemoveWifi === ${deletedWifiName}`);
      reqRemoveWifi(deletedWifiName);

      // 연결된 와이파이 목록에서 삭제
      setWifiConnectedList((prevList) => prevList.filter((_, i) => i !== selectedDeleteIndex));

      // 원본 스캔 데이터에서 삭제된 와이파이와 동일한 SSID를 찾아서 wifiNetworks에 추가
      const matchedNetwork = originalWifiNetworksCache.find(network => network.name === deletedWifiName);
      if (matchedNetwork) {
        setWifiNetworks(prevNetworks => [...prevNetworks, matchedNetwork]);
      }
    }
    handleClickClose();
    setSelectedDeleteIndex(-1);
  };

  /* 와이파이 연결 불가 토스트 메시지 */
  const showWifiWarningToast = () => {
    showErrorToast(
      <span style={{ whiteSpace: "pre-line" }}>
        {intl.formatMessage({ id: "Toast_warning_wifi" })} {/* 저장할 수 있는 Wi-Fi 최대 갯수를 초과했습니다. 나의 Wi-Fi에서 삭제한 뒤 다시 연결해주세요. */}
      </span>
    );
  };


  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    if (error) setError("");
  };

  const onDeviceDisConnected = () => {
    if (isIntentionalDisconnect) {
      setIsIntentionalDisconnect(false);
    } else {
      if (from === "/connect") {
        localStorage.setItem(LocalStorageConnectSkip, "true");
        history.push("/home");
      } else {
        setLoading(false);
        setGlobalPenStatus((prevStatus) => ({
          ...prevStatus, // 현재 상태를 복사
          isConnect: false, // isConnect 속성만 변경
        }));
        setDisconnect(true);
        handleGoSetting();
      }
    }
  };

  const handleNetworkSelect = (index) => {
    if (wifiConnectedList.length > 2) {
      showErrorToast(
        <span style={{ whiteSpace: "pre-line" }}>
          {intl.formatMessage({ id: "Toast_warning_wifi" })} {/* 저장할 수 있는 Wi-Fi 최대 갯수를 초과했습니다. 나의 Wi-Fi에서 삭제한 뒤 다시 연결해주세요. */}
        </span>
      );
    } else if (
      wifiNetworks.length > 0 &&
      index >= 0 &&
      index < wifiNetworks.length
    ) {
      currentWifiNetwork = wifiNetworks[index];  // 전역 변수에 저장
      if (currentWifiNetwork.signalStrength > 0) {
        setSelectedNetwork(index);

        //open wifi
        if (currentWifiNetwork.security < 3 && platform !== "Web") {
          setLoadingText(
            intl.formatMessage({ id: "connecting_to_wifi" })
          );
          setLoading(true);
          wifiInputPassword(currentWifiNetwork.name, "");
        } else {
          setOpenModal(true);
        }
      } else {
        showErrorToast(intl.formatMessage({ id: "wifi_rssi_week" }));
      }
    }
  };

  const handleMyNetworkSelect = (index) => {

    if (
      wifiConnectedList.length > 0 &&
      index >= 0 &&
      index < wifiConnectedList.length

    ) {
      console.log('handleMyNetworkSelect wifiConnectedList:', wifiConnectedList);
      currentWifiNetwork = wifiConnectedList[index];  // 전역 변수에 저장
      console.log('handleMyNetworkSelect currentWifiNetwork:', currentWifiNetwork);
      console.log('handleMyNetworkSelect currentWifiNetwork signalStrength:', currentWifiNetwork.signalStrength);
      if (currentWifiNetwork.signalStrength > 0) {
        // setSelectedNetwork(index);

        setLoadingText(
          intl.formatMessage({ id: "connecting_to_wifi" })
        );
        setLoading(true);
        console.log(`handleMyNetworkSelect name === ${currentWifiNetwork.name}, password=${currentWifiNetwork.password}`);
        wifiInputPassword(currentWifiNetwork.name, currentWifiNetwork.password);
      } else {
        showErrorToast(intl.formatMessage({ id: "wifi_rssi_week" }));
      }
    }
  };


  const handleConnect = () => {
    console.log(`handleConnect === ${password}`);
    if (platform === "Web") {
      if (password === "password") {
        alert(intl.formatMessage({ id: "wifi_connected" }));
        setOpenModal(false);
        setPassword("");
      } else {
        setError(
          intl.formatMessage({ id: "incorrect_password" })
        );
      }
    } else {
      if (password.length > 0 && currentWifiNetwork) {
        setOpenModal(false);
        setLoadingText(
          intl.formatMessage({ id: "connecting_to_wifi" })
        );
        setLoading(true);
        currentWifiNetwork.password = password;
        wifiInputPassword(currentWifiNetwork.name, currentWifiNetwork.password);
      } else {
        setError(
          intl.formatMessage({ id: "enter_password" })
        );
      }
    }
  };

  const handleConnectedNetworkDelete = (index) => {
    console.log(`handleConnectedNetworkDelete === ${index}`);
    if (
      wifiConnectedList.length > 0 &&
      index >= 0 &&
      index < wifiConnectedList.length
    ) {
      console.log(`handleConnectedNetworkDelete reqRemoveWifi === ${wifiConnectedList[index].name}`);
      reqRemoveWifi(wifiConnectedList[index].name);

      setWifiConnectedList((prevList) => prevList.filter((_, i) => i !== index));
    }
  };

  const handleClickOpen = (index) => {
    setSelectedDeleteIndex(index);
    setOpen(true);
  };
  const handleClickClose = () => {
    setOpen(false);
    setSelectedDeleteIndex(-1);
  };



  const handleWifiSuccessClickClose = () => {
    setWifiConnected(false);
    // 팝업 닫기
    // setOpen(false);
    // setSelectedDeleteIndex(-1);
  };
  const handleWifiSuccessClickConfirm = () => {
    // BT 연결 끊고 홈
    setWifiConnected(false);
    setIsIntentionalDisconnect(true); // 의도적인 연결 해제 플래그 설정
    disConnectPokoro();
    setGlobalPenStatus((prevStatus) => ({
      ...prevStatus,
      isConnect: false,
    }));
    // 상태 업데이트가 완료된 후 홈으로 이동
    setTimeout(() => {
      history.push("/home");
    }, 0);
  };

  const handleClose = () => {
    setOpenModal(false);
    setPassword("");
    currentWifiNetwork = null;  // 전역 변수 초기화
  };

  const handleBack = () => {
    history.push("/pokoroSetting");
  };
  
  const handleGoSetting = () => {
    history.push("/pokoroSetting");
  };


  const handleWifiFail = () => {
    setWifiConnectFail(false);
  };

  // 새로운 Wi-Fi 네트워크를 추가하는 함수
  const addWifiNetwork = (name, signalStrength) => {
    // setWifiNetworks((prevNetworks) => [
    //   ...prevNetworks, // 기존 네트워크 목록 유지
    //   { name, signalStrength }, // 새로운 네트워크 추가
    // ]);
  };

  // 여러 개의 Wi-Fi 네트워크를 한꺼번에 추가하는 함수
  const addMultipleWifiNetworks = (newNetworks) => {
    setWifiNetworks((prevNetworks) => [
      ...prevNetworks, // 기존 네트워크 목록 유지
      ...newNetworks, // 새로운 네트워크 목록을 추가
    ]);
  };

  const onDeviceWifiScanFail = () => {
    setLoading(false);
    console.log("WifiConnect ===onDeviceWifiScanFail");
  };

  const onDeviceWifiScanResult = (jsonStr) => {
    console.log(
      `WifiConnect ===onDeviceWifiScanResult ${JSON.stringify(jsonStr)}`
    );
    const wifis = jsonStr.jsonStr;
    const mappedWifiNetworks = wifis.map((network) => {
      const signalStrength = convertSignalStrength(network.rssi);

      if ((globalPenStatus.ConnectedAP1.ssid !== "" && globalPenStatus.ConnectedAP1.ssid === network.wifiName)) {
        mapWifiConnectedList.set(network.wifiName, {
          name: network.wifiName,
          signalStrength: signalStrength,
          icon: getWifiIcon(network.security === 5 ? 5 : signalStrength, network.security >= 3 ? true : false),
          security: network.security,
          password: globalPenStatus.ConnectedAP1.password,
        });
      }
      if ((globalPenStatus.ConnectedAP2.ssid !== "" && globalPenStatus.ConnectedAP2.ssid === network.wifiName)) {
        mapWifiConnectedList.set(network.wifiName, {
          name: network.wifiName,
          signalStrength: signalStrength,
          icon: getWifiIcon(network.security === 5 ? 5 : signalStrength, network.security >= 3 ? true : false),
          security: network.security,
          password: globalPenStatus.ConnectedAP2.password,
        });
      }
      if ((globalPenStatus.ConnectedAP3.ssid !== "" && globalPenStatus.ConnectedAP3.ssid === network.wifiName)) {
        mapWifiConnectedList.set(network.wifiName, {
          name: network.wifiName,
          signalStrength: signalStrength,
          icon: getWifiIcon(network.security === 5 ? 5 : signalStrength, network.security >= 3 ? true : false),
          security: network.security,
          password: globalPenStatus.ConnectedAP3.password,
        });
      }

      return {
        name: network.wifiName,
        signalStrength: signalStrength,
        icon: getWifiIcon(network.security === 5 ? 5 : signalStrength, network.security >= 3 ? true : false),
        security: network.security,
      };
    });

    // 전역 변수에 원본 데이터 저장
    originalWifiNetworksCache = mappedWifiNetworks;

    // React 상태도 업데이트
    setWifiNetworks(mappedWifiNetworks);
    setLoading(false);
    // 연결된 Wi-Fi 목록 요청
    reqPokoroConnectedWifiList();
  };
  useEffect(() => {
    // 매번 연결 시도 전에 reset
    toastShownRef.current = false;
  }, [loading]);

  const toastShownRef = useRef(false); // 중복 방지 플래그

  const onDeviceWifiConnected = () => {
    console.log("onDeviceWifiConnected Called from:", from); // sourceA 또는 sourceB

    //기존과 다르게 와이파이 설정이 되면 토스트와 함께 팝업을 띄워서 펜연결을 끊도록 유도(전에는 무조건 연결 끊었음)
    setLoading(false);
      setPassword("");

      console.log("WifiConnect ===onDeviceWifiConnected currentWifiNetwork:", currentWifiNetwork);

      if (currentWifiNetwork) {
        setWifiConnectedList(prev => {
          const alreadyExists = prev.some(network => network.name === currentWifiNetwork.name);
          if (!alreadyExists) {
            const newList = [...prev, currentWifiNetwork];
            setSelectedConnectedNetwork(newList.length - 1);

            if (!toastShownRef.current) {
              toastShownRef.current = true;
              const networkName = currentWifiNetwork.name;
              showDeleteToast(
                intl.formatMessage(
                  { id: "Toast_priority_connection" },
                  { name: networkName }
                )
              );
            }

            return newList;
          } else {
            const existingIndex = prev.findIndex(network => network.name === currentWifiNetwork.name);
            setSelectedConnectedNetwork(existingIndex);

            if (!toastShownRef.current) {
              toastShownRef.current = true;
              const networkName = currentWifiNetwork.name;
              showDeleteToast(
                intl.formatMessage(
                  { id: "Toast_priority_connection" },
                  { name: networkName }
                )
              );
            }

            return prev;
          }
        });

        setWifiNetworks(prev => prev.filter(network => network.name !== currentWifiNetwork.name));
        setSelectedNetwork(-1);
        currentWifiNetwork = null;
        setWifiConnected(true);
      } else {
        console.log("WifiConnect ===onDeviceWifiConnected: Wi-Fi connection successful but no network info");
      }





    // if (from === "/connect"){
    //   disConnectPokoro();
    // }else{
    //   setLoading(false);
    //   setPassword("");

    //   console.log("WifiConnect ===onDeviceWifiConnected currentWifiNetwork:", currentWifiNetwork);

    //   if (currentWifiNetwork) {
    //     setWifiConnectedList(prev => {
    //       const alreadyExists = prev.some(network => network.name === currentWifiNetwork.name);
    //       if (!alreadyExists) {
    //         const newList = [...prev, currentWifiNetwork];
    //         setSelectedConnectedNetwork(newList.length - 1);

    //         if (!toastShownRef.current) {
    //           toastShownRef.current = true;
    //           const networkName = currentWifiNetwork.name;
    //           showDeleteToast(
    //             intl.formatMessage(
    //               { id: "Toast_priority_connection" },
    //               { name: networkName }
    //             )
    //           );
    //         }

    //         return newList;
    //       } else {
    //         const existingIndex = prev.findIndex(network => network.name === currentWifiNetwork.name);
    //         setSelectedConnectedNetwork(existingIndex);

    //         if (!toastShownRef.current) {
    //           toastShownRef.current = true;
    //           const networkName = currentWifiNetwork.name;
    //           showDeleteToast(
    //             intl.formatMessage(
    //               { id: "Toast_priority_connection" },
    //               { name: networkName }
    //             )
    //           );
    //         }

    //         return prev;
    //       }
    //     });

    //     setWifiNetworks(prev => prev.filter(network => network.name !== currentWifiNetwork.name));
    //     setSelectedNetwork(-1);
    //     currentWifiNetwork = null;
    //   } else {
    //     console.log("WifiConnect ===onDeviceWifiConnected: Wi-Fi connection successful but no network info");
    //   }
    // }





  };
  const onDeviceWifiConnectFail = (msg) => {
    setLoading(false);
    setPassword("");
    console.log(`WifiConnect ===onDeviceWifiConnectFail : ${msg.msg}`);

    if (msg.msg === '0') {
      setWifiFailReasonTitle(
        intl.formatMessage({ id: "wifi_fail_title" })
      );
      setWifiFailReasonMsg(
        intl.formatMessage({ id: "wifi_fail_msg" })
      );
      showErrorToast(intl.formatMessage({ id: "wifi_fail_msg" }));
    } else {
      setWifiFailReasonTitle(
        intl.formatMessage({ id: "wifi_fail_title" })
      );
      setWifiFailReasonMsg(
        intl.formatMessage({ id: "wifi_fail_msg2" })
      );
      showErrorToast(intl.formatMessage({ id: "wifi_fail_msg2" }));
    }




    console.log(`WifiConnect ===onDeviceWifiConnectFail Title: ${wifiFailReasonTitle} , msg:${wifiFailReasonMsg}`);
    setWifiConnectFail(true);
  };


  const onDeviceConnectedWifiResult = (jsonStr, activeSsid) => {
    console.log(
      `WifiConnect ===onDeviceConnectedWifiResult ${JSON.stringify(jsonStr)}, activeSsid: ${activeSsid}`
    );

    const wifis = jsonStr;

    // 1. 연결된 WiFi의 SSID 목록을 Set으로 생성
    const connectedSsids = new Set(wifis.map(wifi => wifi.ssid).filter(ssid => ssid.length > 0));

    // 2. wifiNetworks에서 연결된 WiFi 제거
    setWifiNetworks(prevNetworks =>
      prevNetworks.filter(network => !connectedSsids.has(network.name))
    );

    // 3. 연결된 WiFi 목록 생성
    const mapWifiConnectedList = wifis.map((network) => {
      // 캐시와 상태 모두 확인하여 Wi-Fi 정보 찾기
      const matchedWifi = originalWifiNetworksCache.find((wifi) => network.ssid === wifi.name);
      let signalStrength = 0;
      let security = 0;
      if (matchedWifi) {
        signalStrength = matchedWifi.signalStrength;
        security = matchedWifi.security;
      }
      if (network.ssid.length > 0) {
        return {
          name: network.ssid,
          password: network.pw,
          signalStrength: signalStrength,
          security: security,
          icon: getWifiIcon(security === 5 ? 5 : signalStrength, security >= 3 ? true : false),
        };
      }
      return null;
    }).filter(Boolean);

    setWifiConnectedList(mapWifiConnectedList);

    // activeSsid와 같은 이름의 ssid를 가진 wifi의 인덱스를 찾아 선택
    if (activeSsid) {
      const selectedIndex = mapWifiConnectedList.findIndex(wifi => wifi.name === activeSsid);
      setSelectedConnectedNetwork(selectedIndex);
    }
    setLoading(false);
  };

  const getWifiIcon = (signalStrength, isLock) => {
    switch (signalStrength) {
      case 1:
        if (isLock)
          return <Icon icon="fluent:wifi-lock-24-regular" />; //4칸
        else
          return <Icon icon="fluent:wifi-1-24-regular" />; //4칸
      case 2:
        if (isLock)
          return <Wifi3Lock />; //3칸 잠금
        else
          return <Icon icon="fluent:wifi-2-24-regular" />; //3칸
      case 3:
        if (isLock)
          return <Wifi2Lock />; //2칸 잠금
        else
          return <Icon icon="fluent:wifi-3-24-regular" />; //2칸
      case 4:
        if (isLock)
          return <Wifi1Lock />; //1칸 잠금
        else
          return <Icon icon="fluent:wifi-4-24-regular" />; //1칸
      case 5:
        return <Icon icon="fluent:wifi-off-24-regular" />; //연결불가
      case 6:
        return <Icon icon="fluent:wifi-warning-24-regular" />; //연결에러
      // case 7:
      //   return <Icon icon="fluent:wifi-lock-24-regular" />; //4칸 잠금
      // case 8:
      //   return <Wifi3Lock />; //3칸 잠금
      // case 9:
      //   return <Wifi2Lock />; //2칸 잠금
      // case 10:
      //   return <Wifi1Lock />; //1칸 잠금
      default:
        return <Icon icon="fluent:wifi-5-24-regular" />; //0칸
    }
  };

  // RSSI 값을 신호 강도로 변환하는 함수
  const convertSignalStrength = (rssi) => {
    if (rssi >= -50) return 1; // 신호 강도 4칸
    if (rssi >= -60) return 2; // 신호 강도 3칸
    if (rssi >= -70) return 3; // 신호 강도 2칸
    if (rssi >= -80) return 4; // 신호 강도 1칸
    return 0; // 0칸
  };

  const handleRefresh = () => {
    setWifiNetworks([]);
    setWifiConnectedList([]);

    setLoadingText(intl.formatMessage({ id: "searching_to_wifi" })); /* Wifi를 검색 중입니다.. */
    setLoading(true);
    startWifiScan();
  };

  useEffect(() => {

    console.log("Called from:", from); // sourceA 또는 sourceB
    if(showToast){
      // 페이지 진입 시 포코로 연결 완료 토스트 팝업 표시
      showSuccessToast(
        <span style={{ whiteSpace: "pre-line" }}>
          {intl.formatMessage({ id: "connect_complete_toast" })} {/* 포코로 연결이 완료되었습니다. */}
        </span>
      );
      setLoadingText(intl.formatMessage({ id: "searching_to_wifi" })); /* Wifi를 검색 중입니다.. */
      setLoading(true);
      // 약 1초 후 Wi-Fi 검색 시작
      setTimeout(() => {

        // reqPokoroConnectedWifiList();
        startWifiScan();
      }, 1000);
    }else{
      if (platform === "Web") {
        const dummy = [
          { name: "Wifi01_5G", signalStrength: 1, security: 3 },
          { name: "Wifi02_5G", signalStrength: 2, security: 3 },
          { name: "Wifi03_5G", signalStrength: 3, security: 0 },
          { name: "Wifi04_5G", signalStrength: 4, security: 3 },
          { name: "Wifi05_5G", signalStrength: 5, security: 3 },
          { name: "Wifi06_5G", signalStrength: 6, security: 3 },
          { name: "Wifi07_5G", signalStrength: "default", security: 3 },
        ];
        setWifiNetworks(dummy);
      } else {
        setLoadingText(intl.formatMessage({ id: "searching_to_wifi" })); /* Wifi를 검색 중입니다.. */
        setLoading(true);
        // reqPokoroConnectedWifiList();
        startWifiScan();

      }
    }




    //NativeToJsEventOnDeviceDisConnected
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceDisConnected,
      async (event) => {
        onDeviceDisConnected();
      }
    );

    //NativeToJsEventOnDeviceWifiScanFail
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceWifiScanFail,
      async (event) => {
        onDeviceWifiScanFail();
      }
    );
    //NativeToJsEventOnDeviceWifiScanResult
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceWifiScanResult,
      async (event) => {
        const jsonStr = event;
        onDeviceWifiScanResult(jsonStr);
      }
    );
    //NativeToJsEventOnDeviceWifiConnected
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceWifiConnected,
      async (event) => {
        onDeviceWifiConnected();
      }
    );
    //NativeToJsEventOnDeviceWifiConnectFail
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceWifiConnectFail,
      async (event) => {
        const jsonStr = event;
        onDeviceWifiConnectFail(jsonStr);
      }
    );

    //NativeToJsEventOnDeviceConnectedWifiResult
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceConnectedWifiResult,
      async (event) => {
        const jsonStr = event.jsonStr;
        const activeSsid = event.activeSsid;
        onDeviceConnectedWifiResult(jsonStr, activeSsid);
      }
    );



    // 컴포넌트 언마운트 시 이벤트 제거
    return () => {
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceConnected
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceWifiScanFail
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceWifiScanResult
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceWifiConnected
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceWifiConnectFail
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceConnectedWifiResult
      );
    };
  }, []);

  /* 우선연결 뱃지 */
  // const handleConnectedNetworkClick = (index) => {
  //   setSelectedConnectedNetwork(index);
  //   const networkName = wifiConnectedList[index]?.name || 'test';
  //   showDeleteToast(
  //     intl.formatMessage(
  //       { id: "Toast_priority_connection" }, /* {name}을(를) 우선 연결 Wi-Fi로 설정했습니다. */
  //       { name: networkName }
  //     )
  //   );
  // };

  return (
    <Stack width="100%">
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999, // 충분히 큰 z-index로 다른 요소들 위에 올리기
          }}
        >
          <CommonLoading text={loadingText} />
        </div>
      )}
      <ComfirmDialog
        open={disconnect}
        title={intl.formatMessage({ id: "disconnect_dialog_Title" })}
        contents={intl.formatMessage({ id: "disconnect_dialog_Title" })}
        buttonText={intl.formatMessage({ id: "dialog_confirmButton" })}
        onClick={handleGoSetting}
      />
      <CommonDialog
        open={wifiConnected}
        title={intl.formatMessage({
          id: "wifi_connection_success_title",
        })} /* Wi-Fi 연결 성공 */
        subText={
          <pre>
            {intl.formatMessage({ id: "wifi_connection_success_msg" })}
            {/* 포코로에 Wi-Fi가 연결되었습니다.포코로와 대화하기 위해 블루투스 연결이 끊어집니다. */}
          </pre>
        }
        onClick1={handleWifiSuccessClickClose}
        onClick2={handleWifiSuccessClickConfirm}
        LeftButtonText={intl.formatMessage({ id: "dialog_cancle" })}
        RightButtonText={intl.formatMessage({ id: "dialog_confirmButton" })} 
      />
      <ComfirmDialog
        open={wifiConnectFail}
        title={wifiFailReasonTitle}
        contents={wifiFailReasonMsg}
        buttonText={intl.formatMessage({ id: "dialog_confirmButton" })}
        onClick={handleWifiFail}
      />
      <TitleBox
        title={intl.formatMessage({ id: "wifi_connection" })} /* 와이파이 연결 */
        subtitle={from === "setting" 
          ? intl.formatMessage({ id: "select_wifi2" }) /* POKORO에 연결할 Wi-Fi를 선택한 후 '<(Back)' 버튼을 눌러 설정 페이지로 이동하고 'POKORO 설정 완료' 버튼을 눌러주세요. */
          : intl.formatMessage({ id: "select_wifi" }) /* POKORO에 연결할 Wi-Fi를 선택해주세요. */
        }
        onBack={handleBack}
      />


      {/* 나의 wi-fi */}
      <Stack pt={4} gap={1}>
        <WifiListTitle px={2}>
          <HeaderTitle gap={1}>
            {intl.formatMessage({ id: "connected_wifi_list" })} {/* 나의 Wi-Fi */}
            <Tooltip
              title={intl.formatMessage({ id: "wifi_tooltip" })}
              open={openTooltip}
              onClose={() => setOpenTooltip(false)}
              onOpen={() => setOpenTooltip(true)}
              arrow
              enterDelay={200}
              leaveDelay={3000}
              enterTouchDelay={0}
              leaveTouchDelay={5000}
              slotProps={{
                tooltip: {
                  sx: {
                    fontSize: "13px",
                    padding: "8px 12px",
                    maxWidth: 280,
                    lineHeight: 1.5,
                    "&.MuiTooltip-tooltipPlacementBottom": { marginTop: "5px !important" },
                  },
                },
              }}
            >
              <Icon
                icon="fluent:info-24-regular"
                style={{ cursor: 'pointer' }}
                fontSize={20}
                onClick={handleTooltipToggle}
              />
            </Tooltip>
          </HeaderTitle>
        </WifiListTitle>

        <WifiList spacing={1}>
          {wifiConnectedList.map((network, index) => (
            <WifiItem
              key={index}
              onClick={() => handleMyNetworkSelect(index)}
              style={{ cursor: 'pointer' }}
              selected={selectedConnectedNetwork === index}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                {selectedConnectedNetwork === index && (
                  <Chip
                    label={intl.formatMessage({ id: "priority_connection" })}
                    size="small"
                    sx={{
                      backgroundColor: '#ffb13c',
                      color: '#fff',
                      fontSize: '0.75rem',
                      height: '20px',
                    }}
                  />
                )}
                <Typography>{network.name}</Typography>
              </Stack>
              <Stack flexDirection='row' gap={1}>
                {/* {getWifiIcon(network.signalStrength)} */}
                {getWifiIcon(network.signalStrength, network.security >= 3 ? true : false)}
                <Icon
                  icon="material-symbols-light:delete-outline"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleClickOpen(index);
                  }}
                  style={{ cursor: 'pointer' }}
                />
              </Stack>
            </WifiItem>
          ))}
          {/* Test S */}
          {/*<WifiItem*/}
          {/*  key="test-wifi-1"*/}
          {/*  onClick={() => handleConnectedNetworkClick(0)}*/}
          {/*  style={{ cursor: 'pointer' }}*/}
          {/*  selected={selectedConnectedNetwork === 0}*/}
          {/*>*/}
          {/*  <Stack direction="row" alignItems="center" spacing={1}>*/}
          {/*    {selectedConnectedNetwork === 0 && (*/}
          {/*      <Chip*/}
          {/*        label={intl.formatMessage({ id: "priority_connection" })}*/}
          {/*        size="small"*/}
          {/*        sx={{*/}
          {/*          backgroundColor: '#ffb13c',*/}
          {/*          color: '#fff',*/}
          {/*          fontSize: '0.75rem',*/}
          {/*          height: '20px',*/}
          {/*        }}*/}
          {/*      />*/}
          {/*    )}*/}
          {/*    <Typography>test</Typography>*/}
          {/*  </Stack>*/}
          {/*</WifiItem>*/}
          {/*<WifiItem*/}
          {/*  key="test-wifi-2"*/}
          {/*  onClick={() => handleConnectedNetworkClick(1)}*/}
          {/*  style={{ cursor: 'pointer' }}*/}
          {/*  selected={selectedConnectedNetwork === 1}*/}
          {/*>*/}
          {/*  <Stack direction="row" alignItems="center" spacing={1}>*/}
          {/*    {selectedConnectedNetwork === 1 && (*/}
          {/*      <Chip*/}
          {/*        label={intl.formatMessage({ id: "priority_connection" })}*/}
          {/*        size="small"*/}
          {/*        sx={{*/}
          {/*          backgroundColor: '#ffb13c',*/}
          {/*          color: '#fff',*/}
          {/*          fontSize: '0.75rem',*/}
          {/*          height: '20px',*/}
          {/*        }}*/}
          {/*      />*/}
          {/*    )}*/}
          {/*    <Typography>test2</Typography>*/}
          {/*  </Stack>*/}
          {/*</WifiItem>*/}
          {/* Test E */}
        </WifiList>
      </Stack>
      <LineStyle />

      <Stack pt={4} gap={1}>
        <WifiListTitle px={2}>
          <HeaderTitle>
            {intl.formatMessage({ id: "available_wifi" })}{" "} {/* 연결 가능한 Wi-Fi */}
          </HeaderTitle>
          <Button
            variant="outlined"
            size="small"
            startIcon={<Icon icon="ic:round-refresh" />}
            sx={{
              borderRadius: "20px",
              borderColor: "#909195",
              color: "#909195",
              textTransform: "none",
              fontSize: "0.75rem",
              padding: "2px 8px",
            }}
            onClick={() => handleRefresh()}
          >
            {intl.formatMessage({ id: "refresh" })} {/* 새로고침 */}
          </Button>
        </WifiListTitle>

        <WifiList spacing={1}>
          {wifiNetworks.map((network, index) => (
            <WifiItem
              key={index}
              onClick={network.security === 5 ? null : () => handleNetworkSelect(index)}
              selected={selectedNetwork === index}
              style={{
                pointerEvents: network.security === 5 ? 'none' : 'auto',
                opacity: network.security === 5 ? 0.5 : 1,
              }}
            >
              <Typography>{network.name}</Typography>
              {getWifiIcon(network.security === 5 ? 5 : network.signalStrength, network.security >= 3 ? true : false)}
            </WifiItem>
          ))}
        </WifiList>
        <Box onClick={(e) => {
          if (wifiConnectedList.length > 2) {
            e.preventDefault();
            showErrorToast(intl.formatMessage({ id: "Toast_warning_wifi" })); {/* 저장할 수 있는 Wi-Fi 최대 갯수를 초과했습니다. 나의 Wi-Fi에서 삭제한 뒤 다시 연결해주세요. */ }
          }
        }}>
          <LinkButton to="/newWifiConnect">
            <AddNewWifi px={2}>
              {intl.formatMessage({ id: "add_new_wifi" })}
            </AddNewWifi>
          </LinkButton>
        </Box>
      </Stack>

      <Box width="100%" height="8px" mt={3} bgcolor="#f0f1f5"></Box>
      <ContentsBox py={3}>
        <ListBox>
        <LinkButton to="/networkRegionSetting">
          <Typography variant="body1">
            {intl.formatMessage({ id: "select_region" })} {/* 지역 선택 */}
          </Typography>
          <Stack flexDirection="row" gap={0.5} alignItems="center">
            <Typography className="subTxt">
              {globalPenStatus.serverInfo?.name
                  ? intl.formatMessage({ id: globalPenStatus.serverInfo.name })
                  : intl.formatMessage({ id: "Korea" })}
            </Typography>
            <Icon icon="weui:arrow-outlined" fontSize={20}/>
          </Stack>
        </LinkButton>
        </ListBox>
      </ContentsBox>

      <DialogBox open={openModal} onClose={handleClose}>
        <TitleText>
          {intl.formatMessage({ id: "enter_wifi_password" })}{" "}
          {/* Wi-Fi 비밀번호 입력 */}
        </TitleText>
        <TextStyle color="#909195">
          {intl.formatMessage({ id: "wifi_password_prompt" })}{" "}
          {/* 연결하려는 Wi-Fi의 비밀번호를 입력해주세요. */}
        </TextStyle>
        <ModalContent>
          <Stack flexDirection="row" color="#909195" fontSize={14}>
            {intl.formatMessage({ id: "name" })}{" "}
            <Typography
              variant="body1"
              style={{ color: "#333", marginLeft: "8px" }}
            >
              {wifiNetworks.length > 0 &&
                selectedNetwork >= 0 &&
                selectedNetwork < wifiNetworks.length
                ? wifiNetworks[selectedNetwork].name
                : "No Network Available"}
            </Typography>
          </Stack>
          <InputField
            type={showPassword ? "text" : "password"}
            onChange={handlePasswordChange}
            label={intl.formatMessage({ id: "password" })}
            error={Boolean(error)}
            helperText={error}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleTogglePasswordVisibility}>
                    <Icon
                      icon={
                        showPassword ? "ri:eye-line" : "ri:eye-off-line"
                      }
                    />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{ marginTop: "8px" }}
          />
        </ModalContent>
        <ActionBox sx={{ marginTop: "16px" }}>
          <LeftButtonStyle disableRipple onClick={handleClose}>
            {
              intl.formatMessage({ id: "dialog_cancle" }) //취소
            }
          </LeftButtonStyle>
          <RightButtonStyle disableRipple onClick={handleConnect}>
            {
              intl.formatMessage({ id: "dialog_confirmButton" }) //확인
            }
          </RightButtonStyle>
        </ActionBox>
      </DialogBox>
      <CommonDialog
        open={open}
        title={intl.formatMessage({
          id: "Delete_wifi",
        })} /* Wi-Fi를 삭제하시겠습니까? */
        subText={
          <pre>
            {intl.formatMessage({ id: "Delete_wifi_txt" })}
            {/* 삭제하신 Wi-Fi는 재연결해야 사용 가능하빈다. */}
          </pre>
        }
        onClick1={handleClickClose}
        onClick2={DeleteWifi}
        LeftButtonText={intl.formatMessage({ id: "dialog_cancle" })}
        RightButtonText={intl.formatMessage({ id: "dialog_delete" })} /* 삭제 */
      />
    </Stack>
  );
}

export default injectIntl(inject("authStore")(observer(WifiConnect)));
